import { useQuery } from "@tanstack/react-query";
import { previewMeetingNotesInstructions } from "../api/admin";

// Runs a set of meeting-notes instructions through the real summary pipeline
// against a fixed sample call, so admins can see how their instructions actually
// behave before saving.
//
// Previews are keyed by the exact (trimmed) instruction text and cached hard:
// staleTime Infinity means flicking between presets or instructions never
// re-requests, and the app's default cacheTime (5 days, persisted to IndexedDB
// in index.js) keeps results warm across reloads. Pass previewText === null to
// leave the query idle until the admin actually asks for a preview; an empty
// string is a valid request that previews Sidekick's default notes.
export const useMeetingNotesPreview = (previewText) => {
  const normalized = (previewText ?? "").trim();

  return useQuery({
    queryKey: ["meeting-notes-preview", normalized],
    queryFn: async () => {
      const res = await previewMeetingNotesInstructions({
        meeting_notes_instructions: normalized || null,
      });
      return res.data;
    },
    enabled: previewText !== null,
    staleTime: Infinity,
    keepPreviousData: true,
    retry: false,
  });
};
